import axios, { AxiosError } from 'axios';

import { ROUTES_PATH } from '@/constants';
import InsightService from '@/services/insights';
import TokenService from '@/services/token';
import history from '@/utils/history';
import { modalController } from '@ionic/core';
export const onResponseError = async (
  error: AxiosError | any,
): Promise<AxiosError | any> => {
  InsightService.logEvent('Request', [
    {
      request: {
        requestURL: error.request?.responseURL,
        config: error.config,
      },
    },
    { response: error.data },
  ]);
  const { config } = error;

  InsightService.logException(error);

  if (!error.response?.status) {
    InsightService.logTrace('ResponseError', [
      { code: error.code },
      { config: error.config },
      { status: error.response?.status },
      { errorData: error },
    ]);
  }

  let counter = 0;
  let maxRetries = 0;
  // El cambio de clave no se reintenta: si el primer intento se aplicó, el reintento
  // fallaría y, al agotar los reintentos, la llamada se daría por buena sin serlo
  const isPasswordChange = config?.url?.includes('change-password');
  if (!isPasswordChange && (error.response?.status === 500
    || (error.response?.status === 409
      && !error.request.responseURL.includes('/decisions')))
  ) {
    if (error.response?.status === 500) {
      maxRetries = 1;
    } else {
      maxRetries = 4;
    }
    while (counter < maxRetries) {
      try {
        counter++;
        const response = await axios.request(config);
        return await Promise.resolve(response.data.data);
      } catch (error) {
        if (counter === maxRetries) {
          return;
        }
      }
    }
  } else if (error.response?.status === 401 && !error.response.request.responseURL.includes('reset-password')) {
    console.log('Error 401', error.response);
    TokenService.clearSession();
    history.push(ROUTES_PATH.LOGIN);
    try {
      await modalController.dismiss();
    } catch (error) { }
  } else {
    switch (error?.response?.status) {
      case 400:

        break;
      case 422:

        break;
      case 500:
      case 409:

        break;
      case 404:

        break;
      default:
        break;
    }
  }
  return Promise.reject(error.response?.data || error);

  // const errorCode = error.response.data.result.errors[0].code;
  // const errorStatus = error.response.data.result.http_code;

  // if (
  //   errorCode === LOA0004 ||
  //   errorCode === GEN0003 ||
  //   errorCode === GEN0001 ||
  //   errorCode === LOA0005 ||
  //   errorCode === LOA0011 ||
  //   errorCode === LOA0032
  // ) {
  //   return errorCode;
  // } else if(errorCode === LOA0005){
  //   return 'hola';
  // }

  // if (errorStatus === 401 && errorCode === "USR0003") {
  //   history.push("/login/error");
  // }

  // return Promise.reject(error);
};
